// TMOS Setup Wizard - User Role Permissions Step
// Date: December 19, 2025
// Purpose: User role and permissions assignment step

import React, { useState } from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import { Button } from '@/components/ui/Button';
import { Select } from '@/components/ui/Select';

interface UserRolePermissionsStepProps {
  setupData: Record<string, any>;
  onComplete: (data: Record<string, any>) => void;
  onNext: () => void;
  loading: boolean;
}

const SYSTEM_ROLES = [
  { value: 'T_ADMIN', label: 'Tenant Administrator' },
  { value: 'T_USER', label: 'Tenant User' },
  { value: 'C_ADMIN', label: 'Company Administrator' },
  { value: 'C_USER', label: 'Company User' },
  { value: 'P_ADMIN', label: 'Project Administrator' },
  { value: 'P_USER', label: 'Project User' }
];

export const UserRolePermissionsStep: React.FC<UserRolePermissionsStepProps> = ({
  setupData,
  onComplete,
  loading
}) => {
  const { t } = useLanguage();
  const [selectedRole, setSelectedRole] = useState<string>(
    setupData.assignedRole || ''
  );

  const handleContinue = () => {
    onComplete({
      user_role_permissions: {
        assignedRole: selectedRole
      },
      assignedRole: selectedRole
    });
  };

  return (
    <div className="space-y-6">
      <p className="text-sm text-gray-600 mb-6">
        {t('setupWizard.userRole.description') || 
          'Select your role. This determines what features and data you can access.'}
      </p>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t('setupWizard.userRole.role') || 'Role'} *
        </label>
        <Select
          value={selectedRole}
          onChange={(e) => setSelectedRole(e.target.value)}
          options={[
            { value: '', label: t('common.select') || 'Select role...' },
            ...SYSTEM_ROLES
          ]}
        />
      </div>

      <div className="flex justify-end">
        <Button onClick={handleContinue} disabled={loading || !selectedRole}>
          {t('common.continue') || 'Continue'}
        </Button>
      </div>
    </div>
  );
};

